import { render } from "./HexopayIframe.vue?vue&type=template&id=574bb7c2&scoped=true"
import script from "./HexopayIframe.vue?vue&type=script&lang=js"
export * from "./HexopayIframe.vue?vue&type=script&lang=js"

import "./HexopayIframe.vue?vue&type=style&index=0&id=574bb7c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574bb7c2"]])

export default __exports__